// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const campaign = objectOf({
  id: string,
  name: string,
});

const rule = objectOf({
  name: string,
});

const canvas = objectOf({
  id: string,
  name: string,
});

const frequencyCappingRule = objectOf({
  description: string,
});

export const isGetMessagePrioritizationCategoryDependenciesResult = objectOf({
  campaigns: arrayOf(campaign),
  rules: arrayOf(rule),
  canvases: arrayOf(canvas),
  frequency_capping_rules: arrayOf(frequencyCappingRule),
});
